import React, { useContext, useEffect, useState } from "react";
import { Review } from "./Steps/Review";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { deleteInterview, fetchInterviewByUUID } from "../../services/interview.service";
import { prepareFormData } from "./util";
import {Button, Card, Col, Row, Spin} from "antd";
import { GlobalContext } from "../../context/GlobalContext";
import {getFormattedDate, maskName, noAccess} from "../../utils/common";
import { showSuccessMessage } from "../../utils/notification.util";
import DeleteItemModal from "../../components/layout/DeleteItemModal";
import { fetchCampaignByUUID } from "../../services/campaign.service";
import { getStateNameById } from "../Campaign/utils";
import {roleValues} from "../../config/roles";

export const InterviewDetail = () => {
  const navigate = useNavigate();
  const { setBreadCrumb, user } = useContext(GlobalContext);
  const { campaignUUID, uuid } = useParams();
  const { campaign, setCampaign } = useState({id: '', state: '', district: ''});
  const [interview, setInterview] = useState({createdBy: {}, createdAt: ''}); // [1
  const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (uuid) {
      fetchInterviewByUUID(uuid)
        .then((response) => {
          const apiResponse = response.data;
          setFormData(prepareFormData(apiResponse));
          setInterview(apiResponse);

          if(user?.role === roleValues.dataProtectionOfficer && user?.id !== response.data.createdBy.id) {
            noAccess();
          }
        })
        .catch((error) => {});
    }
    fetchCampaignByUUID(campaignUUID)
    .then((response) => {
      setBreadCrumb([
        {
          title: 'Survivor Identification',
          link: `/location`,
        },
        {
          title: getStateNameById(response.data.state) + ', ' + response.data.district,
          link: `/location/detail/${campaignUUID}`,
        },
        {
          title: 'Survivor',
          link: `/location/${campaignUUID}/interview/detail/${uuid}`,
        },
      ])
      if(user?.role === roleValues.projectCoordinator) {
        if (user?.district !== response.data.district) {
          noAccess();
        }
      }
      if((user?.role === roleValues.dataProtectionOfficer)) {
        if (!(user?.district === response.data.district || user?.id === response?.data?.createdBy?.id)) {
          noAccess();
        }
      }
    })
    .catch((error) => { console.log(error); })
        .finally(() => {setLoading(false)});;
  }, []);
  const deleteRecord = () => {
    deleteInterview(uuid)
      .then(() => {
        showSuccessMessage("Interview deleted successfully");
        navigate(`/location/detail/${campaignUUID}`);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const hasEditPermission = (user.role === roleValues.admin || user.role === roleValues.dataProtectionOfficer || user.role === roleValues.projectCoordinator);
  return (
      <Spin spinning={loading}>
        <div>
          {/*<Card*/}
          {/*  bordered={false}*/}
          {/*  title="Survivor Details"*/}
          {/*  extra={*/}
          {/*    <>*/}
          {/*    { hasEditPermission && <NavLink to={`/location/${campaignUUID}/interview/edit/${uuid}`}>Edit All</NavLink>}*/}
          {/*    </>*/}
          {/*  }*/}
          {/*>*/}

          {/*</Card>*/}
            <Row gutter={[24, 0]} justify="space-between" style={{ padding: "0 10px" }}>
                <Col>
                    <h2>Survivor Details</h2>
                </Col>
                <Col>
                    { hasEditPermission && <NavLink to={`/location/${campaignUUID}/interview/edit/${uuid}`} className={'btn'}>Edit All</NavLink>}
                </Col>
            </Row>

            <Review formData={formData} maskThisFullName={(showHide) => {
                if (showHide) {
                    setFormData(prev => ({...prev, filteredFullName: formData.fullName}));
                } else {
                    setFormData(prev => ({...prev, filteredFullName: maskName(formData.fullName)}));
                }
            }}
                    maskThisPhone={(showHidePhone) => {
                        if (showHidePhone) {
                            setFormData(prev => ({...prev, filteredPhone: formData.contactNumber}));
                        } else {
                            setFormData(prev => ({...prev, filteredPhone: maskName(formData.contactNumber)}));
                        }
                    }}
                    mode={"view"}
                    campaignUUID={campaignUUID}
                    interviewId={uuid}
            />
            <div>
                <i style={{padding: "20px"}}>Created by: {interview.createdBy.fullName}, {getFormattedDate(interview.createdAt, 'MMMM DD, YYYY')}</i>
                {/* <Button type="danger" onClick={() => deleteRecord()} style={{float: 'right', marginBottom: '15px', marginRight: '10px'}} >Delete</Button> */}
                <span style={{float: 'right', marginBottom: '15px', marginRight: '10px'}}><DeleteItemModal onDelete={deleteRecord} item={''} buttonType={'default'} text={'Delete All'} /></span>
            </div>
        </div>
      </Spin>
  );
};
